import { FC } from "react"
import { SchedulesBatchUpdate } from "../../../../module/schedules/containers/batchUpdate"

export const SchedulesCollectiveBatchUpdatePage: FC = () => (
  <SchedulesBatchUpdate />
)
